import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  inputWrapper: {
    display: "flex",
    flexDirection: "column",
    width: ({ fullWidth }) => (fullWidth ? "100%" : "auto"),
  },
  label: {
    fontSize: 14,
    fontStyle: "normal",
    lineHeight: "20px",
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    fontWeight: 400,
  },
  helperTextContainer: {
    height: theme.spacing(3),
    marginBottom: theme.spacing(0.5),
  },
  helperText: {
    fontSize: theme.typography.pxToRem(12),
    margin: 0,
    color: ({ error }) =>
      error ? theme.palette.error.main : theme.palette.text.secondary,
  },
  requiredAsterisk: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(0.5),
  },
}));

export const FieldWrapper = ({
  label,
  error,
  helperText,
  fullWidth,
  required,
  children,
}) => {
  const classes = useStyles({ fullWidth, error });

  return (
    <div className={classes.inputWrapper}>
      <label className={classes.label}>
        {label}
        {required && <span className={classes.requiredAsterisk}>*</span>}
      </label>
      {children}
      {(error || helperText) && (
        <div className={classes.helperTextContainer}>
          <p className={classes.helperText}>{error || helperText}</p>
        </div>
      )}
    </div>
  );
};

FieldWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default FieldWrapper;
